module.exports = __webpack_public_path__ + "static/media/clock-transparent.567125ac.png";